
/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

Mindbreeze.define('service/channel',[
   "require",
    "underscore",
    "backbone",
    "client/localized_model"
  ], function(
    require,
    _,
    Backbone,
    LocalizedModel
  ) {

  var Trace;
  require(["utils/trace"], function (t) { Trace = t; });

  var ProxyResponseObserver = function (responseObserver, callback) {
    this.traceContext = responseObserver && responseObserver.traceContext;

    this.on("all", function (type) {
      callback.apply(this, arguments);
      if (responseObserver) {
        responseObserver.trigger.apply(responseObserver, arguments);
      }
    });
  }
  _.extend(ProxyResponseObserver.prototype, Backbone.Events);

  //
  // channel documents the
  //
  var Channel = LocalizedModel.extend({
    localizedProperties: ["title", "description"],

    defaults: {
      enabled: true
    },

    initialize: function (attributes, options) {
      this.set("id", this.get("url"));
      this.set("trace", this.get("trace") !== false);
      if (options != null)
        this.options = options;
    },

    // call is the method that is implemented by a channel in order to
    // get a response for that request.
    //
    // @param request  - a JSON object representing the requeest
    // @param ctx      - an object that is carried around for identifying the same objects
    // @return         - a promise that the call
    
    call: function (path, request, responseObserver, formatOptions, callHeaders, options) {
      if (!this.get("enabled")) return;

      var headers = {};
      if (this.options && this.options.headers) {
        headers = _.extend(headers, this.options.headers);
      }
      headers = _.extend(headers, callHeaders);

      if (request && request.name && _.isString(request.name)) {
        headers["x-mes-api-request-name"] = request.name;
      }
      
      
      if (this.get("trace")) {
        var leave;
        if (Trace) {
          leave = Trace.events.httpRequest.enter(responseObserver && responseObserver.traceContext && responseObserver.traceContext.context, path, this.get("url"));

          headers = Trace.adaptRequestHeaders(headers ? _.clone(headers) : null, leave.context);
        }

        responseObserver = new ProxyResponseObserver(responseObserver, function (type, response) {
            var status = response.status,
                statusDescription = response.error;

            if (/response/i.test(type)) {
              status = "200";
              statusDescription = "OK";
            }

            if (leave) leave.leave(status, statusDescription);
        });
      }

      var args = _.toArray(arguments);
      args[4] = headers;

      return this.internalCall.apply(this, args);
    },

    success: function (data, promise, responseObserver) {
      if (responseObserver) { responseObserver.trigger("response", data, this); }
      promise.triggerDone(data);
    },

    error: function (err, promise, responseObserver) {
      if (responseObserver) responseObserver.trigger("error", err, this);
      promise.triggerFail(err);
    },

    internalCall: function (path, request, responseObserver, dataType, headers) {
      responseObserver.trigger("error", {status: 500, message: "Channel.call is abstract!"});
      var result = new DeferredCallFinished();
      result.triggerFail();
      return result;
    },

    get: function (key) {
      if (key === "checked") {
        return this.get("enabled") ? "checked" : "";
      }
      if (key === "name") {
        return this.get("title") || this.get("url").replace(/api\/v2\/$/, "");
      }
      return LocalizedModel.prototype.get.apply(this, arguments);
    },

    // every channel has an id
    id: null

  });

  function _forward(target, event, args) {
    var args = [event, target].concat(Array.prototype.slice.call(args));
    target.trigger.apply(target, args);
  }

  // A Deferred Event that fires when the complete call is finished
  //
  var DeferredCallFinished = Channel.DeferredCallFinished = function(channel) {
    this.channel = channel;
    this._finished = false;
    this._failed = true;
    if (this.channel) {
      this.once("fail", function() { _forward(this.channel, "fail", arguments); }, this );
      this.once("done", function() { _forward(this.channel, "done", arguments); }, this );
    }
    this.on("fail done", 
            function(/*..*/) {
              this._finished = true;
            }, 
            this);
    this.initialize.apply(this, arguments);
  };

  _.extend(DeferredCallFinished.prototype, Backbone.Events, {

    initialize: function() {},

    triggerFail: function(/*args*/) {
      this._failed = true;
      this._finished = true;
      var args = ["fail"].concat(Array.prototype.slice.call(arguments));
      this.trigger.apply(this, args);
    },
    triggerDone: function(/*args*/) {
      this._failed = false;
      this._finished = true;
      var args = ["done"].concat(Array.prototype.slice.call(arguments));
      this.trigger.apply(this, args);
    },

    isDone: function() {
      return this._finished && !this._failed;
    },

    isFailed: function() {
      return this._finished && this._failed;
    },

    always: function(callback, context) {
      if (this.isFailed() || this.isDone()) {
        var that = context || this;
        callback.call(that);
      }
      this.on("fail done", callback, context);
    },

    fail: function(callback, context) {
      if (this.isFailed()) {
        var that = context || this;
        callback.call(that);
      }
      this.on("fail", callback, context);
    },

    done: function(callback, context) {
      if (this.isDone()) {
        var that = context || this;
        callback.call(that);
      }
      this.on("done", callback, context);
    }

  });

  return Channel;
});
